import { sendEvent } from '../../../configs/firebase'

interface NPSSubmitPayload {
  score: number | null
  hasReason: boolean
  hasImprovementSuggestion: boolean
}

type NPSCloseSource = 'survey' | 'thanks' | 'unknown'
type NPSCloseAction = 'dismiss_button' | 'close_button' | 'outside_click'

const professionalNPSAnalytics = {
  trackSurveyView(): void {
    sendEvent('professional_nps_survey_view')
  },

  trackScoreSelected(score: number): void {
    sendEvent('professional_nps_score_selected', { score })
  },

  trackSkip(): void {
    sendEvent('professional_nps_skip')
  },

  trackSubmit(payload: NPSSubmitPayload): void {
    sendEvent('professional_nps_submit', payload)
  },

  trackThanksView(): void {
    sendEvent('professional_nps_thanks_view')
  },

  trackClose(
    source: NPSCloseSource,
    action: NPSCloseAction = 'close_button'
  ): void {
    sendEvent('professional_nps_close', { source, action })
  },
}

export default professionalNPSAnalytics
